<template>
  <div id="app">
    <div class="card border-primary" style="margin-bottom: 20px">
      <div class="card-header">
        <h5 style="margin-bottom: 0px">
          Sport Radar Odds Comparison Prematch API
        </h5>
      </div>

      <div class="card-body">
        <div class="form-row">
          <div class="col">
            <div class="form-group" v-if="sports.length > 0">
              <label>Sports</label>
              <select @change="selectSport" class="form-control">
                <option value="">-- Select --</option>
                <option
                  v-for="sport in sports"
                  :value="sport.id"
                  :key="sport.id"
                >
                  {{ sport.name }}
                </option>
              </select>
            </div>
          </div>

          <div class="col">
            <div class="form-group" v-if="competitions.length > 0">
              <label>Competitions</label>
              <select @change="selectCompetition" class="form-control">
                <option value="">-- Select --</option>
                <option
                  v-for="competition in competitions"
                  :value="competition.id"
                  :key="competition.id"
                >
                  {{ competition.name }}
                  {{ getCompetitionCountry(competition) }}
                </option>
              </select>
            </div>
          </div>

          <div class="col">
            <div class="form-group" v-if="competitionSportEvents.length > 0">
              <label>Sport events</label>
              <select @change="selectSportEvent" class="form-control">
                <option value="">-- Select --</option>
                <option
                  v-for="event in competitionSportEvents"
                  :value="event.sport_event.id"
                  :key="event.sport_event.id"
                >
                  {{ event.sport_event.start_time }} -
                  {{ getSportEventName(event.sport_event) }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div>
          <p>These are the SportRadar's endpoints used to build this page.</p>
          <table class="table" style="text-align: left">
            <tr>
              <td>Books</td>
              <td>
                <a :href="getBooksEndpoint(true)" target="_blank">{{
                  getBooksEndpoint(true)
                }}</a>
              </td>
            </tr>
            <tr v-if="sportId">
              <td>Sport Categories</td>
              <td>
                <a :href="getSportCategoriesEndpoint(true)" target="_blank">{{
                  getSportCategoriesEndpoint(true)
                }}</a>
              </td>
            </tr>
            <tr>
              <td>Sports</td>
              <td>
                <a :href="getSportsEndpoint(true)" target="_blank">{{
                  getSportsEndpoint(true)
                }}</a>
              </td>
            </tr>
            <tr v-if="sportId && getSportCompetitionsEndpoint()">
              <td>Sport Competitions</td>
              <td>
                <a :href="getSportCompetitionsEndpoint(true)" target="_blank">{{
                  getSportCompetitionsEndpoint(true)
                }}</a>
              </td>
            </tr>
            <tr
              v-if="competitionId && getCompetitionSportEventMarketsEndpoint()"
            >
              <td>Competition Sport Event Markets</td>
              <td>
                <a
                  :href="getCompetitionSportEventMarketsEndpoint(true)"
                  target="_blank"
                  >{{ getCompetitionSportEventMarketsEndpoint(true) }}</a
                >
              </td>
            </tr>
            <tr v-if="sportId && dateToday">
              <td>Daily Sport Event Markets</td>
              <td>
                <a
                  :href="getDailySportEventMarketsEndpoint(true)"
                  target="_blank"
                  >{{ getDailySportEventMarketsEndpoint(true) }}</a
                >
              </td>
            </tr>
          </table>
        </div>

        <div>
          <p>
            There are more exmaples of SportRadar's Odds Comparison Prematch API
          </p>
          <table class="table" style="text-align: left">
            <tr>
              <td>Competition Mappings</td>
              <td>
                <a
                  :href="getCompetitionMappingsEndpoint(true)"
                  target="_blank"
                  >{{ getCompetitionMappingsEndpoint(true) }}</a
                >
              </td>
            </tr>
            <tr>
              <td>Competitor Mappings</td>
              <td>
                <a
                  :href="getCompetitorMappingsEndpoint(true)"
                  target="_blank"
                  >{{ getCompetitorMappingsEndpoint(true) }}</a
                >
              </td>
            </tr>
            <tr>
              <td>Player Mappings</td>
              <td>
                <a :href="getPlayerMappingsEndpoint(true)" target="_blank">{{
                  getPlayerMappingsEndpoint(true)
                }}</a>
              </td>
            </tr>
            <tr>
              <td>Sport Event Mappings</td>
              <td>
                <a
                  :href="getSportEventMappingsEndpoint(true)"
                  target="_blank"
                  >{{ getSportEventMappingsEndpoint(true) }}</a
                >
              </td>
            </tr>
            <tr v-if="sportEventId">
              <td>Sport Event Markets</td>
              <td>
                <a :href="getSportEventMarketsEndpoint(true)" target="_blank">{{
                  getSportEventMarketsEndpoint(true)
                }}</a>
              </td>
            </tr>
            <tr>
              <td>Sport Event Markets Change Log</td>
              <td>
                <a
                  :href="getSportEventMarketsChangeLogEndpoint(true)"
                  target="_blank"
                  >{{ getSportEventMarketsChangeLogEndpoint(true) }}</a
                >
              </td>
            </tr>
            <tr>
              <td>Sport Stages</td>
              <td>
                <a :href="getSportStagesEndpoint(true)" target="_blank">{{
                  getSportStagesEndpoint(true)
                }}</a>
              </td>
            </tr>
            <tr>
              <td>Stage Mappings</td>
              <td>
                <a :href="getStageMappingsEndpoint(true)" target="_blank">{{
                  getStageMappingsEndpoint(true)
                }}</a>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>

    <div id="accordion">
      <div v-if="books.length > 0" class="card">
        <div class="card-header" id="headingZero">
          <h5 class="mb-0">
            <button
              class="btn btn-link"
              data-toggle="collapse"
              data-target="#books"
              aria-expanded="true"
              aria-controls="collapseZero"
            >
              All books available
            </button>
          </h5>
        </div>

        <div id="books" class="collapse show" aria-labelledby="headingZero">
          <div class="card-body">
            <table class="table">
              <tr>
                <th>Id</th>
                <th>Name</th>
              </tr>
              <tr v-for="book in books" :key="book.id" :value="book.id">
                <td>
                  {{ book.id }}
                </td>
                <td>
                  {{ book.name }}
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>

      <div v-if="categories.length > 0" class="card">
        <div class="card-header" id="headingOne">
          <h5 class="mb-0">
            <button
              class="btn btn-link"
              data-toggle="collapse"
              data-target="#categories"
              aria-expanded="true"
              aria-controls="collapseOne"
            >
              All categories available
            </button>
          </h5>
        </div>

        <div id="categories" class="collapse show" aria-labelledby="headingOne">
          <div class="card-body">
            <table class="table">
              <tr>
                <th>Id</th>
                <th>Name</th>
                <th>Country code</th>
              </tr>
              <tr
                v-for="category in categories"
                :key="category.id"
                :value="category.id"
              >
                <td>
                  {{ category.id }}
                </td>
                <td>
                  {{ category.name }}
                </td>
                <td>
                  {{ category.country_code }}
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>

      <div v-if="sportEventId" class="card">
        <div class="card-header" id="headingTwo">
          <h5 class="mb-0">
            <button
              class="btn btn-link"
              data-toggle="collapse"
              data-target="#game"
              aria-expanded="true"
              aria-controls="collapseTwo"
            >
              Competition Sport Event Markets
            </button>
          </h5>
        </div>

        <div id="game" class="collapse show" aria-labelledby="headingTwo">
          <div class="card-body">
            <h6 style="font-weight: bold">
              {{ getSportEventName(sportEvent.sport_event) }}
            </h6>

            <table class="table">
              <tr>
                <th>scheduled</th>
                <th>home</th>
                <th>away</th>
              </tr>
              <tr v-if="sportEvent">
                <td>
                  id: {{ sportEvent.sport_event.id }}<br />
                  scheduled: {{ sportEvent.sport_event.start_time }}<br />
                  is date confirmed:
                  {{ sportEvent.sport_event.start_time_confirmed }}
                </td>
                <td>
                  id: {{ home.id }}<br />
                  name: {{ home.name }}<br />
                  country: {{ home.country }}<br />
                  country_code: {{ home.country_code }}<br />
                  abbreviation: {{ home.abbreviation }}<br />
                  qualifier: {{ home.qualifier }}<br />
                  rotation_number: {{ home.rotation_number }}<br />
                </td>
                <td>
                  id: {{ away.id }}<br />
                  name: {{ away.name }}<br />
                  country: {{ away.country }}<br />
                  country_code: {{ away.country_code }}<br />
                  abbreviation: {{ away.abbreviation }}<br />
                  qualifier: {{ away.qualifier }}<br />
                  rotation_number: {{ away.rotation_number }}<br />
                </td>
              </tr>
            </table>

            <h6>Markets</h6>
            <SportEventMarkets :markets="sportEvent.markets">
            </SportEventMarkets>
          </div>
        </div>
      </div>

      <div v-if="dailySportEvents.length > 0" class="card">
        <div class="card-header" id="headingThree">
          <h5 class="mb-0">
            <button
              class="btn btn-link"
              data-toggle="collapse"
              data-target="#daily"
              aria-expanded="true"
              aria-controls="collapseThree"
            >
              Daily Sport Event Markets
            </button>
          </h5>
        </div>

        <div id="daily" class="collapse show" aria-labelledby="headingThree">
          <div
            class="card-body"
            v-for="event in dailySportEvents"
            :key="event.id"
            :value="event.id"
            style="border-bottom: 1px solid #ccc"
          >
            <h6 style="font-weight: bold">
              {{ getSportEventName(event.sport_event) }}
            </h6>

            <table class="table">
              <tr>
                <th>scheduled</th>
                <th>home</th>
                <th>away</th>
              </tr>
              <tr v-if="event.sport_event">
                <td>
                  id: {{ event.sport_event.id }}<br />
                  scheduled: {{ event.sport_event.start_time }}<br />
                  is date confirmed:
                  {{ event.sport_event.start_time_confirmed }}
                </td>
                <td
                  :set="
                    (homeCompetitor = getHomeCompetitor(
                      event.sport_event.competitors
                    ))
                  "
                >
                  id: {{ homeCompetitor.id }}<br />
                  name: {{ homeCompetitor.name }}<br />
                  country: {{ homeCompetitor.country }}<br />
                  country_code: {{ homeCompetitor.country_code }}<br />
                  abbreviation: {{ homeCompetitor.abbreviation }}<br />
                  qualifier: {{ homeCompetitor.qualifier }}<br />
                  rotation_number: {{ homeCompetitor.rotation_number }}<br />
                </td>
                <td
                  :set="
                    (awayCompetitor = getAwayCompetitor(
                      event.sport_event.competitors
                    ))
                  "
                >
                  id: {{ awayCompetitor.id }}<br />
                  name: {{ awayCompetitor.name }}<br />
                  country: {{ awayCompetitor.country }}<br />
                  country_code: {{ awayCompetitor.country_code }}<br />
                  abbreviation: {{ awayCompetitor.abbreviation }}<br />
                  qualifier: {{ awayCompetitor.qualifier }}<br />
                  rotation_number: {{ awayCompetitor.rotation_number }}<br />
                </td>
              </tr>
            </table>

            <h6>Markets</h6>
            <SportEventMarkets :markets="event.markets"> </SportEventMarkets>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SportEventMarkets from "./components/SportEventMarkets.vue";
import axios from "axios";

const API_KEY = "nk36crjecxm2sxx459yg5nz5";

export default {
  name: "app",
  components: {
    SportEventMarkets,
  },
  data: function () {
    return {
      apiKey: API_KEY,
      sports: [],
      books: [],
      categories: [],
      competitions: [],
      competitionSportEvents: [],
      dailySportEvents: [],
      sportId: "",
      competitionId: "",
      dateToday: "",
      sportEventId: "",
      sportEvent: "",
      home: "",
      away: "",
    };
  },
  created: function () {
    this.loadSports();
    this.loadBooks();
    this.getDateToday();
  },
  methods: {
    getDateToday: function () {
      const today = new Date();
      const yyyy = today.getFullYear();
      let mm = today.getMonth() + 1;
      let dd = today.getDate();

      if (dd < 10) dd = "0" + dd;
      if (mm < 10) mm = "0" + mm;

      this.dateToday = yyyy + "-" + mm + "-" + dd;
    },

    getCompetitionCountry: function (competition) {
      return competition && competition.category && competition.category.name
        ? competition.category.name
        : null;
    },

    getSportEventName: function (event) {
      return event && event.competitors[0] && event.competitors[0].name
        ? event.competitors[0].name + " vs " + event.competitors[1].name
        : null;
    },

    getHomeCompetitor: function (competitors) {
      return competitors.find((competitor) => competitor.qualifier == "home");
    },

    getAwayCompetitor: function (competitors) {
      return competitors.find((competitor) => competitor.qualifier == "away");
    },

    loadBooks: function () {
      // get full list of books
      axios.get(this.getBooksEndpoint(), { crossdomain: true }).then(
        (response) => {
          console.log("books", response.data.books);

          this.books = response.data.books;
        },
        (error) => {
          console.log(error);
        }
      );
    },

    loadSports: function () {
      // get full list of sports
      axios.get(this.getSportsEndpoint(), { crossdomain: true }).then(
        (response) => {
          console.log("sports", response.data.sports);

          this.sports = response.data.sports;
        },
        (error) => {
          console.log(error);
        }
      );
    },

    loadCompetitions: function () {
      // get full list of competitions
      axios
        .get(this.getSportCompetitionsEndpoint(), { crossdomain: true })
        .then(
          (response) => {
            console.log("competitions", response.data.competitions);

            this.competitions = response.data.competitions;
          },
          (error) => {
            console.log(error);
          }
        );
    },

    loadCategories: function () {
      // get full list of categories
      axios.get(this.getSportCategoriesEndpoint(), { crossdomain: true }).then(
        (response) => {
          console.log("categories", response.data.categories);

          this.categories = response.data.categories;
        },
        (error) => {
          console.log(error);
        }
      );
    },

    loadCompetitionSportEventMarkets: function () {
      // get full list of sport events
      axios
        .get(this.getCompetitionSportEventMarketsEndpoint(), {
          crossdomain: true,
        })
        .then(
          (response) => {
            console.log(
              "competition sport event markets",
              response.data.competition_sport_event_markets
            );

            this.competitionSportEvents =
              response.data.competition_sport_event_markets;
          },
          (error) => {
            console.log(error);
          }
        );
    },

    loadDailySportEventMakets: function () {
      // get full list of daily sport events
      axios
        .get(this.getDailySportEventMarketsEndpoint(), { crossdomain: true })
        .then(
          (response) => {
            console.log(
              "daily sport event markets",
              response.data.sport_schedule_sport_event_markets
            );

            this.dailySportEvents =
              response.data.sport_schedule_sport_event_markets;
          },
          (error) => {
            console.log(error);
          }
        );
    },

    selectSport: function (event) {
      this.sportId = event.target.value;
      this.competitionSportEvents = [];
      this.dailySportEvents = [];
      this.sportEventId = "";
      this.sportEvent = "";
      this.loadCompetitions();
      this.loadCategories();
    },

    selectCompetition: function (event) {
      this.competitionId = event.target.value;
      this.competitionSportEvents = [];
      this.dailySportEvents = [];
      this.sportEventId = "";
      this.sportEvent = "";
      this.loadCompetitionSportEventMarkets();
      this.loadDailySportEventMakets();
    },

    selectSportEvent: function (event) {
      this.sportEventId = event.target.value;
      this.sportEvent = this.competitionSportEvents.find(function (game) {
        return game.sport_event.id == event.target.value;
      });

      this.home = this.getHomeCompetitor(
        this.sportEvent.sport_event.competitors
      );
      this.away = this.getAwayCompetitor(
        this.sportEvent.sport_event.competitors
      );
    },

    // ---- start: used endpoints only ---- //
    getSportsEndpoint: function (showBetradarUrl = false) {
      let url = `https://api.sportradar.us/oddscomparison-prematch/production/v2/en/sports.json?api_key=${this.apiKey}`;

      if (showBetradarUrl) {
        url = url.replace(
          "https://kaxmatrix.com/oddsapi",
          "https://api.sportradar.us"
        );
      }

      return url;
    },
    getSportCompetitionsEndpoint: function (showBetradarUrl = false) {
      let url = `https://api.sportradar.us/oddscomparison-prematch/production/v2/en/sports/${this.sportId}/competitions.json?api_key=${this.apiKey}`;

      if (showBetradarUrl) {
        url = url.replace(
          "https://kaxmatrix.com/oddsapi",
          "https://api.sportradar.us"
        );
      }

      return url;
    },
    getCompetitionSportEventMarketsEndpoint: function (
      showBetradarUrl = false
    ) {
      let url = `https://api.sportradar.us/oddscomparison-prematch/production/v2/en/competitions/${this.competitionId}/sport_event_markets.json?api_key=${this.apiKey}`;

      if (showBetradarUrl) {
        url = url.replace(
          "https://kaxmatrix.com/oddsapi",
          "https://api.sportradar.us"
        );
      }

      return url;
    },
    // ---- end: used endpoints only ---- //

    // ---- start: example endpoints only ---- //
    getBooksEndpoint: function (showBetradarUrl = false) {
      let url = `https://api.sportradar.us/oddscomparison-prematch/production/v2/en/books.json?api_key=${this.apiKey}`;

      if (showBetradarUrl) {
        url = url.replace(
          "https://kaxmatrix.com/oddsapi",
          "https://api.sportradar.us"
        );
      }

      return url;
    },
    getCompetitionMappingsEndpoint: function (showBetradarUrl = false) {
      let url = `https://api.sportradar.us/oddscomparison-prematch/production/v2/en/competitions/mappings.json?api_key=${this.apiKey}`;

      if (showBetradarUrl) {
        url = url.replace(
          "https://kaxmatrix.com/oddsapi",
          "https://api.sportradar.us"
        );
      }

      return url;
    },
    getCompetitorMappingsEndpoint: function (showBetradarUrl = false) {
      let url = `https://api.sportradar.us/oddscomparison-prematch/production/v2/en/competitors/mappings.json?api_key=${this.apiKey}`;

      if (showBetradarUrl) {
        url = url.replace(
          "https://kaxmatrix.com/oddsapi",
          "https://api.sportradar.us"
        );
      }

      return url;
    },
    getDailySportEventMarketsEndpoint: function (showBetradarUrl = false) {
      let url = `https://api.sportradar.us/oddscomparison-prematch/production/v2/en/sports/${this.sportId}/schedules/${this.dateToday}/sport_event_markets.json?api_key=${this.apiKey}`;

      if (showBetradarUrl) {
        url = url.replace(
          "https://kaxmatrix.com/oddsapi",
          "https://api.sportradar.us"
        );
      }

      return url;
    },
    getPlayerMappingsEndpoint: function (showBetradarUrl = false) {
      let url = `https://api.sportradar.us/oddscomparison-prematch/production/v2/en/players/mappings.json?api_key=${this.apiKey}`;

      if (showBetradarUrl) {
        url = url.replace(
          "https://kaxmatrix.com/oddsapi",
          "https://api.sportradar.us"
        );
      }

      return url;
    },
    getSportCategoriesEndpoint: function (showBetradarUrl = false) {
      let url = `https://api.sportradar.us/oddscomparison-prematch/production/v2/en/sports/${this.sportId}/categories.json?api_key=${this.apiKey}`;

      if (showBetradarUrl) {
        url = url.replace(
          "https://kaxmatrix.com/oddsapi",
          "https://api.sportradar.us"
        );
      }

      return url;
    },
    getSportEventMappingsEndpoint: function (showBetradarUrl = false) {
      let url = `https://api.sportradar.us/oddscomparison-prematch/production/v2/en/sport_events/mappings.json?api_key=${this.apiKey}`;

      if (showBetradarUrl) {
        url = url.replace(
          "https://kaxmatrix.com/oddsapi",
          "https://api.sportradar.us"
        );
      }

      return url;
    },
    getSportEventMarketsEndpoint: function (showBetradarUrl = false) {
      let url = `https://api.sportradar.us/oddscomparison-prematch/production/v2/en/sport_events/${this.sportEventId}/sport_event_markets.json?api_key=${this.apiKey}`;

      if (showBetradarUrl) {
        url = url.replace(
          "https://kaxmatrix.com/oddsapi",
          "https://api.sportradar.us"
        );
      }

      return url;
    },
    getSportEventMarketsChangeLogEndpoint: function (showBetradarUrl = false) {
      let url = `https://api.sportradar.us/oddscomparison-prematch/production/v2/en/sport_event_markets_changelog.json?api_key=${this.apiKey}`;

      if (showBetradarUrl) {
        url = url.replace(
          "https://kaxmatrix.com/oddsapi",
          "https://api.sportradar.us"
        );
      }

      return url;
    },
    getSportStagesEndpoint: function (showBetradarUrl = false) {
      let url = `https://api.sportradar.us/oddscomparison-prematch/production/v2/en/sports/${this.sportId}/stages.json?api_key=${this.apiKey}`;

      if (showBetradarUrl) {
        url = url.replace(
          "https://kaxmatrix.com/oddsapi",
          "https://api.sportradar.us"
        );
      }

      return url;
    },
    getStageMappingsEndpoint: function (showBetradarUrl = false) {
      let url = `https://api.sportradar.us/oddscomparison-prematch/production/v2/en/stages/mappings.json?api_key=${this.apiKey}`;

      if (showBetradarUrl) {
        url = url.replace(
          "https://kaxmatrix.com/oddsapi",
          "https://api.sportradar.us"
        );
      }

      return url;
    },
    // ---- end: example endpoints only ---- //
  },
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin-top: 60px;
  font-size: 12px;
}

table {
  width: 100%;
}
</style>